import { ApiError } from './api';

/**
 * Srozumitelná česká hláška při neúspěšném uložení dokumentu.
 *
 * Dřív `handleSave` chybu nijak neošetřoval — když uložení selhalo (vypršelé
 * přihlášení, výpadek sítě…), uživatel nedostal žádnou zpětnou vazbu a myslel
 * si, že se uložilo. Tahle funkce převede chybu na hlášku do toastu.
 */
export function docSaveErrorMessage(e: unknown): string {
  if (e instanceof ApiError) {
    if (e.status === 401)
      return 'Uložení se nezdařilo — vypršelo přihlášení. Přihlaste se prosím znovu a zkuste to znovu.';
    if (e.status === 413) return 'Uložení se nezdařilo — dokument je příliš velký.';
    const detail = (e.detail as { detail?: unknown } | undefined)?.detail;
    if (typeof detail === 'string' && detail.trim())
      return `Uložení se nezdařilo: ${detail}`;
    return `Uložení se nezdařilo (chyba ${e.status}). Zkuste to prosím znovu.`;
  }
  return 'Uložení se nezdařilo. Zkontrolujte připojení a zkuste to prosím znovu.';
}
